import { render, staticRenderFns } from "./SubscriptionPlanView.vue?vue&type=template&id=0ca64d4d"
import script from "./SubscriptionPlanView.vue?vue&type=script&lang=js"
export * from "./SubscriptionPlanView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports